// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "x") return "static/css/x.0cf0a132.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}